/*
 * @Author: zxl
 * @Date: 2020-04-20 11:49:06
 * @FilePath: \serveradmin_frontend\src\utils\Csv\index.js
 * @Description: 
 */
import Csv from './Csv'
import ExportCsv from './ExportCsv'

const exportCsv = params => {
  if (params.filename) {
    if (params.filename.indexOf('.csv') === -1) {
      params.filename += '.csv';
    }
  } else {
    params.filename = 'table.csv';
  }
  let columns = [];
  let datas = [];
  if (params.columns && params.data) {
    columns = params.columns;
    datas = params.data;
  } else {
    columns = this.allColumns;
    if (!('original' in params)) params.original = true;
    datas = params.original ? this.data : this.rebuildData;
  }
  let noHeader = false;
  if ('noHeader' in params) noHeader = params.noHeader;
  const data = Csv(columns, datas, params, noHeader);
  if (params.callback) params.callback(data);
  else ExportCsv.download(params.filename, data);
}

export default exportCsv